// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingBox_container__17Ma2","content":"LandingBox_content__1dcEP"};